import FencelineConfig from "@/apps/fenceline/app.config"
import homeConfig from "@/apps/home/app.config"
import supportConfig from "@/apps/tutorials/app.config"
import customLeftNav from "@/apps/custom-left-nav/app.config"


var configs = [
    FencelineConfig,
    //homeConfig,
    //supportConfig,
    //customLeftNav
];


var registrationConfig = configs.map(e => {
    return {
        store: e.storeModule,
        route: e.route,
    }
});

export default registrationConfig;
